import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Truck, Users, Wrench, FileBarChart } from 'lucide-react';

export const MobileFieldOperations: React.FC = () => {
  return (
    <div className="p-4 space-y-4">
      <div className="text-center mb-6">
        <h1 className="text-2xl font-bold text-foreground mb-2">Field Operations</h1>
        <p className="text-muted-foreground">Manage crews, equipment, and field activities</p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Card className="bg-card/50 border-border hover:bg-card/70 transition-colors">
          <CardContent className="p-4 text-center">
            <Users className="h-8 w-8 mx-auto mb-2 text-primary" />
            <p className="text-sm text-foreground font-medium">Scheduler</p>
          </CardContent>
        </Card>

        <Card className="bg-card/50 border-border hover:bg-card/70 transition-colors">
          <CardContent className="p-4 text-center">
            <Wrench className="h-8 w-8 mx-auto mb-2 text-primary" />
            <p className="text-sm text-foreground font-medium">Equipment</p>
          </CardContent>
        </Card>

        <Card className="bg-card/50 border-border hover:bg-card/70 transition-colors">
          <CardContent className="p-4 text-center">
            <FileBarChart className="h-8 w-8 mx-auto mb-2 text-primary" />
            <p className="text-sm text-foreground font-medium">Reporting</p>
          </CardContent>
        </Card>

        <Card className="bg-card/50 border-border hover:bg-card/70 transition-colors">
          <CardContent className="p-4 text-center">
            <Truck className="h-8 w-8 mx-auto mb-2 text-primary" />
            <p className="text-sm text-foreground font-medium">Arbor Note</p>
          </CardContent>
        </Card>
      </div>

      <div className="mt-6">
        <Card className="bg-card/30 border-border">
          <CardHeader>
            <CardTitle className="text-foreground text-lg">Today's Schedule</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground text-sm">No scheduled activities for today</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};